import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import {
  Modal,
  ModalBody,
} from 'reactstrap';
import {
  Button,
  Col,
  Icon,
  RSelect,
  Row,
} from "../../components/Component";

import * as moment from "moment";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import { getDefaultCustomerMoneyFlow } from "../../utils/Utils";
import UpsertCustomerMoneyFlowComponent from './upsertcustomermoneyflowcomponent/UpsertCustomerMoneyFlowComponent';



const AddCustomerMoneyFlow = ({
  onClose,
  type: initType,
  id: initId,
  transactionId,
  defaultValue = {},
}) => {
  const [id, setId] = useState(initId);
  const [type, setType] = useState(initType)
  const [showFormRequestUpdate, setShowFormRequestUpdate] = useState(false);
  const [haveRequestUpdate, setHaveRequestUpdate] = useState(null);
  const [userOptions, setUserOptions] = useState([]);

  const methodForm = useForm({
    defaultValues: getDefaultCustomerMoneyFlow(defaultValue),
  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
  } = methodForm;

  const isEdit = !!id;
  useEffect(() => {
    GET("/user/list-can-confirm-request-update", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });
    if (isEdit) {
      GET(`/customer-money-flow/${id}`, {}, true).then((resp) => {
        reset(resp.data);
        const { haveRequestUpdate } = resp.data

        if (haveRequestUpdate) {
          setHaveRequestUpdate(haveRequestUpdate)
        }
      });
    }

    if (transactionId) {
      GET(`/customer-money-flow/get-by-transactionId/${transactionId}`, {}, true).then((resp) => {
        reset(resp.data);
        setType(resp.data.type);
        setId(resp.data.id)
        const { haveRequestUpdate } = resp.data
        if (haveRequestUpdate) {
          setHaveRequestUpdate(haveRequestUpdate)
        }
      });
    }
  }, []);

  const parseDataSubmit = (data) => {
    const {
      amount,
      bankAccountId,
      content,
      customerId,
      note,
      receiver,
      date,
      exchangeRate,
      amountUSD,
      currency,
      reviewerId,
      reason,
      hookTransactionHistoryId,
    } = data;

    const formData = {
      date: moment(date).format("YYYY-MM-DD"),
      amount,
      bankAccountId,
      content,
      customerId,
      note,
      receiver,
      type,
      exchangeRate,
      amountUSD,
      currency,
      reviewerId,
      reason,
      hookTransactionHistoryId: hookTransactionHistoryId ? Number(hookTransactionHistoryId) : null,
    };
    return formData;
  }
  const onHandleSubmit = () => {

    const formData = parseDataSubmit(getValues());
    const request = isEdit
      ? PUT(`customer-money-flow/${id}`, formData, {}, true)
      : POST("customer-money-flow", { ...formData }, {}, true);

    request
      .then((res) => {
        if (isEdit) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        if (onClose) {
          onClose();
        }
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => { });
  };

  const onRequestUpdate = () => {
    const formData = parseDataSubmit(getValues());
    PUT(`/customer-money-flow/request-update/${id}`, formData, {}, true)
      .then((res) => {
        toast.success("Gửi yêu cầu thành công");
        if (onClose) {
          onClose();
        }
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })

  };


  const [view, setView] = useState({
    isDelete: false,
  });


  const [deleteId, setDeleteId] = useState();

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };


  const resetData = () => {
    setDeleteId(null)
    onFormCancel();
  };

  const onFormCancel = () => {
    setView({ isDelete: false });
  };


  const deleteCustomerMoneyFlow = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/customer-money-flow/${id}`, {}, true)
      .then((res) => {
        toast.success(`Xóa thành công`);
        resetData();
        if (onClose) {
          onClose();
        }
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <div className="card card-bordered card-preview">
      <div className="card-inner">
        <h3>
          {(!isEdit ? "Thêm" : "Sửa") + " lịch sử " + (type === 'OUT' ? "thanh toán" : "thu tiền")}

        </h3>
        <FormProvider {...methodForm}>
          <UpsertCustomerMoneyFlowComponent type={type} />
          <Row>
            <Col md="12">
              {showFormRequestUpdate ? (
                <Row>

                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Người duyệt
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="reviewerId"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              classNamePrefix="form-control"
                              inputRef={ref}
                              name={name}
                              options={userOptions}
                              value={userOptions.find(
                                (c) => c.value === value
                              )}
                              onChange={(val) => onChange(val.value)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="reviewerId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col size="12">
                    <div className="form-group">
                      <label className="form-label" >
                        Lý do cập nhật<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <textarea
                          rows={3}
                          className="form-control"
                          style={{ height: "unset" }}
                          name="reason"
                          ref={register({
                            required: "Vui lòng nhập thông tin",
                          })}
                          disabled={haveRequestUpdate}
                        />
                        <ErrorMessage errors={errors} name="reason" render={({ message }) => <span className="invalid">{message}</span>} />
                      </div>
                      <div className="mt-2">
                        <Button disabled={haveRequestUpdate} color="primary" type="button" className={"mr-2"} onClick={handleSubmit(onRequestUpdate)}>
                          <span>Gửi yêu cầu cập nhật</span>
                        </Button>
                        <Button color="primary" type="button" onClick={() => setShowFormRequestUpdate(false)}>
                          <span>Ẩn yêu cầu sửa thu chi</span>
                        </Button>

                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col size="12" className={"mt-4"}>
                    <Button color="primary" type='button' className={`mr-2`} onClick={handleSubmit(onHandleSubmit)}>
                      <span>Lưu giao dịch</span>
                    </Button>
                    {
                      isEdit ? <Button color="primary" type="button" onClick={() => setShowFormRequestUpdate(true)}>
                        <span>Hiện yêu cầu sửa thu chi</span>
                      </Button> : <></>
                    }

                    {isEdit ? <Button color="danger" className={`ml-2`} type="button" onClick={() => {
                      setDeleteId(id);
                      toggle("isDelete");
                    }}>
                      <span>Xoá dữ liệu</span>
                    </Button> : <></>}

                  </Col>
                </Row>
              )}

            </Col>
          </Row>
        </FormProvider>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteCustomerMoneyFlow(deleteId);
                  }}
                >
                  Xác nhận
                </Button>

              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default AddCustomerMoneyFlow;
